<template>
  <v-container class="home">
    <v-row>
      <v-col>
        <h1>Bienvenido a MozDesigner Viewer.</h1>
        <p>Seleccione un fichero para visualizarlo</p>
        <input type="file" @change="fileSelected" ref="fileInput">
      </v-col>
    </v-row>

    <v-snackbar v-model="showError" color="red">
      Ocurrió un error al leer el fichero.
    </v-snackbar>
    
    <v-snackbar v-model="showVersionError" color="red">
      El fichero está en una versión no compatible. Por favor, expórtelo de nuevo.
    </v-snackbar>

    <v-overlay :value="showLoader">
      <v-progress-circular indeterminate
                           :size="64"
                           :width="7"></v-progress-circular>
      <div>Cargando diseño...</div>
    </v-overlay>
  </v-container>
</template>

<script>
// @ is an alias to /src
import designService from '../services/design.service';

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      showError: false,
      showVersionError: false,
      showLoader: false,
    };
  },
  methods: {
    fileSelected(ev) {
      if (!ev.target.files || !ev.target.files.length) {
        return;
      }
      this.showError = false;
      this.showVersionError = false;
      this.showLoader = true;
      designService.readFile(ev.target.files[0])
        .then((design) => {
          if (design.blockCount > 1) {
            this.$router.push('select-block');
          } else {
            this.$router.push('view-block');
          }
        })
        .catch((e) => {
          console.log(e);
          this.$refs.fileInput.value = null;
          if (e === 'VersionError') {
            this.showVersionError = true;
          } else {
            this.showError = true;
          }
        })
        .finally(() => {
          this.showLoader = false;
        });
    }
  },
}
</script>
